import moment from 'moment';
import React from 'react';
import { DosageTime } from 'models/ui';
import { DATE_FORMAT, DATE_FORMAT_MAR } from 'constants/app.constant';
import { Box } from 'components/common';
import { ELSCheckBox } from 'components/common/els';

export type HoldUnholdDosageItem = DosageTime & { checked: boolean };

interface MarHoldUnholdItemProps {
  dosageItem: HoldUnholdDosageItem;
  isSingle: boolean;
  onToggle: Function;
}

// One selectable dosage-time card in the Hold/Unhold sidebar (SIMSNG-6033), modeled on
// MarAdministerItem. The medication header renders once in the sidebar, not per card.
const MarHoldUnholdItem = ({ dosageItem, isSingle, onToggle }: MarHoldUnholdItemProps) => {
  const dosageMoment = moment(dosageItem.dosageDate, DATE_FORMAT);
  const dosageDateTime = `${dosageMoment.format(DATE_FORMAT_MAR)} | ${dosageItem.dosageTime} | ${dosageMoment.format('dddd')}`;

  return (
    <Box className="mar-hold-unhold-sidebar__container">
      <div className="mar-hold-unhold-sidebar__container__info">
        {!isSingle && <ELSCheckBox checked={dosageItem.checked} changeHandler={() => onToggle(dosageItem)} />}
        <div className="mar-hold-unhold-sidebar__container__info__text">
          <div className="mar-hold-unhold-sidebar__container__info__text__time">{`Dosage Date & Time: ${dosageDateTime}`}</div>
        </div>
      </div>
    </Box>
  );
};

MarHoldUnholdItem.displayName = 'MarHoldUnholdItem';
export default MarHoldUnholdItem;
